import { components } from 'react-select'

import type { ReactElement } from 'react'
import type { ControlProps } from 'react-select'
import type { ISelectOption } from '~/types/option'

import './styles.scss'

const CustomControl = ({ children, ...props }: ControlProps): ReactElement => {
  const image = props.selectProps.value ? (props.selectProps.value as ISelectOption).image : null

  return (
    <components.Control {...props}>
      {!image ? null : <div className="control-image-container">{image}</div>}
      {children}
    </components.Control>
  )
}

export default CustomControl
